<template>
  <div id="login-view">
    <div
      class="modal fade"
      id="loginModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close pb-2"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="form-title text-center">
              <h4 class="pt-3">Login</h4>
            </div>
            <div class="d-flex flex-column text-center">
              <b-overlay :show="loader" rounded="sm">
                <form>
                  <div class="form-group">
                    <input
                      type="email"
                      class="form-control"
                      v-model="email"
                      placeholder="Your email address..."
                    />
                    <span class="text-danger" v-if="errors.email">{{
                      this.errors.email[0]
                    }}</span>
                  </div>
                  <div class="form-group password-container">
                    <input
                     id="passwordInput"
                      type="password"
                      class="form-control"
                      v-model="password"
                      placeholder="Your password..."
                    />
                    <span
                      class="password-toggle"
                      @click="togglePasswordVisibility"
                    >
                      <i
                        class="fas"
                        :class="passwordVisible ? 'fa-eye': 'fa-eye-slash'"
                      ></i>
                    </span>
                    <span class="text-danger" v-if="errors.password">{{
                      this.errors.password[0]
                    }}</span>
                  </div>
                  <button
                    type="button"
                    class="btn btn-secondary btn-block"
                    @click="login"
                  >
                    Login
                  </button>
                </form>
              </b-overlay>
              <div class="row">
                <div class="col-8">
                  <span class="text-danger">{{ error_msg }}</span>
                </div>
              </div>
              <div class="text-center text-muted delimiter">
                or use a social network
              </div>
              <div class="d-flex justify-content-center social-buttons">
                <button
                  type="button"
                  class="btn-google mx-lg-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Google"
                  @click="AuthProvider('google')"
                >
                  <i class="bx bxl-google"></i>
                </button>
                <button
                  type="button"
                  class="btn-facebook mx-lg-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Facebook"
                  @click="AuthProvider('facebook')"
                >
                  <i class="bx bxl-facebook"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <div class="row d-flex">
              <div class="col-md-6">
                <div class="signup-section">
                  Not a member yet?
                  <button
                    type="button"
                    class="btn btn-secondary btn-round col-md-8 mt-2"
                    @click="ShowverificationForm()"
                  >
                    Sign up
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <div class="signup-section">
                  Not remember password?
                  <center>
                    <button
                      type="button"
                      class="btn btn-secondary btn-round col-md-10 mt-2"
                      @click="ShowForgotForm()"
                    >
                      Forgot Password
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "LoginView",
  data() {
    return {
      email: null,
      password: null,
      errors: [],
      error_msg: null,
      loader: false,
      userData: [],
      firstname: "",
      passwordVisible: false,
    };
  },
  methods: {
    ShowverificationForm() {
      console.log("hii");
      this.$emit("ShowVerification", true);
    },
    ShowForgotForm() {
      this.$emit("ShowForgotForm", true);
    },
    AuthProvider(provider) {
      var self = this;
      this.$auth
        .authenticate(provider)
        .then((response) => {
          self.SocialLogin(provider, response);
        })
        .catch((err) => {
          console.log({ err: err });
        });
    },
    SocialLogin(provider, response) {
      this.$http
        .post(
          process.env.VUE_APP_URL +
            "customer/socialRedirect/" +
            provider,
          response
        )
        .then((response) => {
          console.log(response.data);
          this.checkRegister(response.data);
        })
        .catch((err) => {
          console.log({ err: err });
        });
    },
    login() {
      this.errors = [];
      this.error_msg = null;
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "customer/customerLogin";
      let method_type = "post";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          email: this.email,
          password: this.password,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            var userData = {
              user: data.customer,
              status: true,
            };
            console.log(userData);
            localStorage.setItem("userData", JSON.stringify(userData));
            if (process.env.NODE_ENV === "development") {
              window.location.href =
                "http://localhost:8081/account/" +
                data.customer.cross_pltaform_token;
            } else {
              window.location.href =
                "https://account.aixperia.com/account/" +
                data.customer.cross_pltaform_token;
            }
          } else if (data.status === false && data.message != null) {
            localStorage.clear();
            this.loader = false;
            this.error_msg = data.message;
          } else {
            this.loader = false;
            this.errors = data.errors;
          }
        })
        .catch(function (err) {
          console.log("User Data", "Error : " + err.message, "error");
        });
    },
    checkRegister(details) {
      this.errors = [];
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "customer/saveRegister";
      let method_type = "post";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          userdetail: details.user,
          provider: details.provider,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          if (data.status === true) {
            var userData = {
              user: data.customer,
              status: true,
            };
            localStorage.setItem("userData", JSON.stringify(userData));
             $('#loginModal').modal('hide'); 
            if (process.env.NODE_ENV === "development") {
              window.location.href =
                "http://localhost:8081/account/" +
                data.customer.cross_pltaform_token;
            } else {
              window.location.href =
                "https://account.aixperia.com/account/" +
                data.customer.cross_pltaform_token;
            }
          }
          if (data.status === false) {
            this.$swal("Error", data.message, "error");
          } else {
            this.loader = false;
            this.errors = data.errors;
          }
        })
        .catch(function (err) {
          console.log("Register Data", "Error : " + err.message, "error");
        });
    },
    togglePasswordVisibility() {
       this.passwordVisible = !this.passwordVisible;
    const passwordInput = document.getElementById('passwordInput');
    if (this.passwordVisible) {
      passwordInput.type = 'text';
    } else {
      passwordInput.type = 'password';
    }
  },
    
  },
};
</script>
<style scoped>
.password-container {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.password-toggle i {
  color: #333;
}
</style>
